// extracted by css-extract-rspack-plugin
export default {"Box":"slicer-panel-resizer-module__Box__z4xabZx","Box_1":"slicer-panel-resizer-module__Box_1__sE8Tqa5","isDragging":"slicer-panel-resizer-module__isDragging__LdfZT61"};